<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="待审核信息"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :get-data-func="api.getReviewList"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column prop="Class1" label="大类" />
        <el-table-column prop="Class2" label="细类" />
        <el-table-column prop="Submitter" label="提交人" width="90" />
        <el-table-column prop="SubmitTime" label="提交时间" width="150" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {},
  data() {
    return {
      api: require("@/api/gd/common").default,
      params: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>